// @flow

import _ from 'lodash';
import moment from 'moment';

export default class PhotoShooting {
  active: boolean;
  id: string;
  date: Object;

  constructor(data: any = {}) {
    this.active = !_.isEmpty(data);
    this.id = data.id || '';
    this.date = moment(data.photoshooting_date_time);
  }
}
